import { LEARNING_GOAL_OPTIONS } from 'bundles/onboarding-common/constants';
import type { QuestionValue } from 'bundles/onboarding-common/types';

import _t from 'i18n!nls/onboarding-common';

const getLearningGoalOptionName = () => ({
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_LAND_NEW_JOB]: _t('Start my career'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_CHANGE_CAREER]: _t('Change my career'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_IMPROVE_SKILLS]: _t('Grow in my current role'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_PERSONAL_INTEREST]: _t('Explore topics outside of work'),
});

const isQuestionAnswered = (questionValue: QuestionValue | null | undefined) => {
  if (!questionValue || questionValue.value === null) {
    return false;
  }
  switch (questionValue.__typename) {
    case 'role-select':
    case 'role-select-advancer':
    case 'skill-select':
      return questionValue.value.length > 0;

    case 'job-title':
      return !!questionValue.value.id || !!questionValue.value.name || !!questionValue.value.otherText;
    case 'learning-goal':
    case 'education-level':
      return questionValue.value !== null;
    default:
      return true;
  }
};

const slugifyCustomRoleName = (name?: string): string => {
  return (name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9._-]+/g, '')
    .replace(/[^a-z0-9]+$/, '');
};

const getIdontKnowOption = () => ({
  id: 'i-dont-know',
  name: _t("I don't know"),
  type: 'UNSURE' as const,
});

const getFirstName = (fullName?: string) => {
  if (!fullName) {
    return '';
  }
  return fullName.trim().split(' ')[0] || '';
};

export { getLearningGoalOptionName, isQuestionAnswered, slugifyCustomRoleName, getIdontKnowOption, getFirstName };
